import { useEffect, useState } from "react";
import { toast } from "sonner";
import { http } from "@/lib/api";
import { Card, PageTitle, btnPrimary, fieldCls } from "@/components/portal/ui";

export default function Profile() {
  const [child, setChild] = useState(null);
  const [form, setForm] = useState({ name: "", age_months: "", dob: "", notes: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    http.get("/portal/children").then((r) => {
      if (r.data[0]) { setChild(r.data[0]); setForm({ name: r.data[0].name || "", age_months: r.data[0].age_months || "", dob: r.data[0].dob || "", notes: r.data[0].notes || "" }); }
    }).catch(() => {});
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      const body = { ...form, age_months: form.age_months ? Number(form.age_months) : null };
      if (child) { const r = await http.put(`/portal/children/${child.id}`, body); setChild(r.data); }
      else { const r = await http.post("/portal/children", body); setChild(r.data); }
      toast.success("Sleep profile saved");
    } catch (e) { toast.error("Could not save"); } finally { setBusy(false); }
  };

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  return (
    <div>
      <PageTitle eyebrow="One persistent profile" title="My Sleep Profile"
        sub="This profile stays with your account and flows into every service. Use Review & Update — you never start over." />
      <Card className="p-7 max-w-2xl space-y-5">
        <div>
          <label className="block text-sm text-[#6B665E] mb-2">Child's first name</label>
          <input data-testid="profile-name" className={fieldCls} value={form.name} onChange={(e) => set("name", e.target.value)} />
        </div>
        <div className="grid sm:grid-cols-2 gap-5">
          <div>
            <label className="block text-sm text-[#6B665E] mb-2">Age (months)</label>
            <input data-testid="profile-age" type="number" className={fieldCls} value={form.age_months} onChange={(e) => set("age_months", e.target.value)} />
          </div>
          <div>
            <label className="block text-sm text-[#6B665E] mb-2">Date of birth (optional)</label>
            <input data-testid="profile-dob" type="date" className={fieldCls} value={form.dob || ""} onChange={(e) => set("dob", e.target.value)} />
          </div>
        </div>
        <div>
          <label className="block text-sm text-[#6B665E] mb-2">Anything you'd like your Certified Infant Sleep Consultant to know</label>
          <textarea data-testid="profile-notes" rows={3} className={fieldCls} value={form.notes} onChange={(e) => set("notes", e.target.value)} />
        </div>
        <button data-testid="profile-save" onClick={save} disabled={busy || !form.name} className={btnPrimary}>{busy ? "Saving…" : "Save profile"}</button>
        <p className="text-xs text-[#8A998C]">This information is private customer service data. It is never sent to marketing or analytics.</p>
      </Card>
    </div>
  );
}
